import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TripService } from '../services/trip.service';

/** Mobile route for team-document upload — only while the trip is active. */
export const teamDocumentUploadGuard: CanActivateFn = () => {
  const tripService = inject(TripService);
  const router = inject(Router);

  if (!tripService.currentTripLoaded()) {
    return true;
  }

  if (tripService.hasEnded()) {
    return router.createUrlTree(['/prep-planning']);
  }

  return true;
};
